import React, { useRef,useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import "./request_new_access_for_self.css";
import SearchForAnApplication from "./search_for_an_application.tsx";
import {
  Button,
  ButtonIcon,
  Search,
  Checkbox,
  Icon,
  Slot,
  Modal,
  Dropdown,
  Breadcrumb
} from "pepsico-ds";
import Tooltip from "../landing/tooltip.jsx";
import ArfFormAttributes from "../landing/access_request_forms.jsx";
import "../requests/requests.css";
import requestsService from "./requestsservice";
import { useLocation, useNavigate } from "react-router-dom";
import app_image from "../../assets/app_image.png";
import {toast,ToastContainer} from 'react-toastify';
import { useLoading } from "../../loader.jsx";

// Define types for request options
interface RequestOption {
    label: string;
    desc: string;
    id: string;
    isBadge?: boolean;
    newApproverLevels?: Array<[]>;
    myidm?: boolean;
    currentAccessApp: boolean;
    modifyDisableRequestInProgress:boolean;
    newRequestInProgress:boolean;
    pepAppViewType:string;
  }

  type Toast = {
    id: string;
    duration: number;
    text: string;
    type: string;
    position: string;
  };

const RequestNewAccessForSelf = () => {
      const { control } = useForm();
      const { REACT_APP_API_ENDPOINT } = process.env;
      const navigate = useNavigate();
      const { state } = useLocation();
      const [searchText, setSearchText] = useState<string>("");
      const [requests, setRequests] = useState<RequestOption[]>([]);
      const [requestsList,setRequestsList] = useState<RequestOption[]>([]);
      const [requestsCondition,setRequestsCondition] = useState<RequestOption[]>([]);
      const [selectedItems, setSelectedItems] = useState<RequestOption[]>([]);
      const [showSearchText,setShowSearchText] =  useState<string>("");
      const [currentAccessApps, setCurrentAccessApps] = useState<RequestOption[]>([]);
      const [currentAccesslist, setCurrentAccessList] = useState<RequestOption[]>([]);
      const [selectedId, setSelectedId] = useState<RequestOption | null>(null);
      const [toasts, setToasts] = useState<Toast[]>([]);
      const [searchbyDivision, setSearchbyDivision] = useState(false);
      const [gpid, setGpid] = useState("");
      const [selectedOption, setSelectedOption] = useState<RequestOption[]>([]);
      const [roleList, setRolesList] = useState([]);
      const [selectedRequestTabIndex, setSelectedRequestTabIndex] = useState<number>(0);  
      const[divisions,setDivisions]= useState<DropdownItem[]>([]);
      const[functions,setFunctions]= useState<DropdownItem[]>([]);
      const[roles,setRoles]= useState<DropdownItem[]>([]);
      const [mode,setMode]= useState('');
      const [selectedDivision, setSelectedDivision] = useState('');
      const [selectedFunction, setSelectedFunction] = useState('');
      const [selectedRole, setSelectedRole] = useState('');
      const [isMobile, setIsMobile] = useState(false);
      const [expandedItems, setExpandedItems] = useState({});
      const { showLoader, hideLoader } = useLoading();
      const [searchedKeywords,setSearchedKeywords] = useState('');
      const descRefs = useRef({});
      const [showMoreVisible, setShowMoreVisible] = useState({});
      const { t } = useTranslation();
    
      const toggleExpand = (index) => {
        setExpandedItems((prev) => ({
          ...prev,
          [index]: !prev[index],
        }));
      };

    useEffect(() => {
    const updatedVisibility = {};
  
    requests.forEach((item) => {
      const el = descRefs.current[item.id];
      if (el) {
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
        const maxHeight = lineHeight * 2;
        updatedVisibility[item.id] = el.scrollHeight > maxHeight;
      }
    });
  
    setShowMoreVisible(updatedVisibility);
  }, [requests]);
      const callSearchAPI = async (val: string): Promise<void> => {
        
        try {
          showLoader();
          const appList = await requestsService.getAppList(val,gpid);
          if(Array.isArray(appList) && appList?.length == 0){
            hideLoader()
            // showToast(1,"No applications matched the specified keyword.",'error')
            toast.error("No applications matched the specified keyword.")
          }
          if (Array.isArray(appList) && appList.length > 0) {
          const sortedApps = [...appList].sort((a, b) =>
            a.label.localeCompare(b.label)
          );
          setRequests(sortedApps)
          setShowSearchText(searchText);
          }
          // setRequests((prevRequests) => [
          //   ...prevRequests,
          //   ...appList.filter(
          //     (newApp) => !prevRequests.some((existingApp) => existingApp.id === newApp.id)
          //   )
          // ]);
          hideLoader();
        } catch (error) {
          hideLoader();
          // showToast(4,error.message,'error');
          toast.error(error.message);
          console.error("Failed to fetch app list:", error.message);
        }
      };
    
      const showToast = (index: number, message: string, type: string) => {
        setToasts([
          {
            id: `toast-${index}`,
            duration: 10000,
            text: message,
            type: type,
            position: "bottom-right",
          },
        ]);
      };
    
      const removeSelectedAPP = (item) => {
        setSelectedItems((prevSelected) =>
          prevSelected.filter((i) => i.id !== item.id)
        );
      };
    
      const removeToast = (id) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
      };
      
      const gotoMyidm = (item)=>{
        if(!item.myidm){
          window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?facesViewId=/app/page/association/user_association.jsp", "_blank");
        }
      }
      
      const handleToggle = (item) => {
        if(!item.myidm || item.currentAccessApp || item.newRequestInProgress || item.modifyDisableRequestInProgress){
          return;
        }
        else {
          setSelectedItems((prevSelected: any) => {
            const isSelected = prevSelected.some((i: any) => i.id === item.id);
            if (isSelected) {
              // Deselect: remove from array
              return prevSelected.filter((i: any) => i.id !== item.id);
            } else {
              // Select: add to array
              return [...prevSelected, item];
            }
          });
        }
      };
      
    const [checkedItems, setCheckedItems] = useState(() => {
    const initialState = [];
    currentAccessApps.forEach(item => {
        initialState[item.id] = item.isBadge;
    });
    return initialState;
    });
    const data = JSON.parse(localStorage.getItem("okta-token-storage") ?? "{}");
      const callCurrentAccessAPI = async (val: string): Promise<void> => {
        try {
          showLoader();
          const currentAppList = await requestsService.getCurrentAccessAppList(val);
          setCurrentAccessApps(currentAppList);
          setCurrentAccessList(currentAppList);
          hideLoader();
        } catch (error) {
          console.error("Failed to fetch app list:", error.message);
          hideLoader();
        }
      };
      
      type DropdownItem = {
        id: string;
        displayText: string;
      };
    
      const handleDivisionChange = (e) => {
        setSelectedDivision(e);
        
        if(roleList){
          const data = roleList['roleData'];
          const functionItems: DropdownItem[] =
          Object.keys(data[e[0]['id']]).map(func => ({
            id: func,
            displayText: func
          }))  
          setFunctions(functionItems);  
        }
        
      };
    
      const handleFunctionChange = (e) => {
        setSelectedFunction(e);
        const data = roleList['roleData'];
        // Convert third-level values (roles) to DropdownItem[]
        const div = selectedDivision[0]['id'];
        const fun = e[0]['id'];
        const roleItems: DropdownItem[] = data[div][fun].map((role: string) => ({
            id: role,
            displayText: role
          }))
    
        setRoles(roleItems);
        setSelectedRole('');
      };
    
      const handleRoleChange = (e) => {
        setSelectedRole(e);
      };
    
      const callGetRolesAPI = async (): Promise<void> => {
        try {
          showLoader();
          const currentAppList = await requestsService.getRolesList();
          setRolesList(currentAppList);
          const data = currentAppList['roleData'];      
          const dropdownItems: DropdownItem[] = Object.keys(data).map(item => ({
            id: item,
            displayText: item
          }));
    
          setDivisions(dropdownItems);
          console.log('0909009090909090',divisions);
          hideLoader();
        } catch (error) {
          console.error("Failed to fetch app list:", error);
          hideLoader();
        }
      };
      useEffect(() => {
        const checkScreenSize = () => {
          setIsMobile(window.innerWidth <= 768);
        };
    
        checkScreenSize(); // Initial check
        window.addEventListener('resize', checkScreenSize); // Listen for resize
    
        return () => window.removeEventListener('resize', checkScreenSize);
      }, []);
      
      useEffect(() => {
        console.log('111111111111111111',state);
        if(state?.selectedid){
          setSelectedId(state?.selectedid);
          setMode('NEW')
        }
        if(state?.value){
          setGpid(state?.value);
        }
        if(!state?.value){
          if (!gpid && data?.accessToken?.claims?.gpid) {
            setGpid(data?.accessToken?.claims?.gpid);
          }
        }
        console.log('2222222222222222222',gpid);
        if (gpid) {
          // callCurrentAccessAPI(gpid);
          // callGetRolesAPI();
        }
      }, [state?.type, state?.value,gpid]);
    
      const divisionBySearchClick = ()=> {
        // if(val== 1){
          setSearchbyDivision(true);
          callGetRolesAPI();
        // }
        // if(val.id == 2){
        //   setSearchbyDivision(false);
        // }
      };
    
      const updateSearchText = (val: string): void => {
        setSearchText(val);
      };
    
      // const getAppSearch = (searchText: string) => {
      //   console.log('Search text:', searchText);
      //   if (searchText && searchText.trim() !== "") {
      //     const filtered = requestsList.filter(app =>
      //       app.label.toLowerCase().includes(searchText.toLowerCase())
      //     );
      //     setRequests(filtered);
      //   } else {
      //     // Reset to full list when input is cleared
      //     setRequests(requests);
      //   }
      // };
    
      const getAppRequestTypes = (val: string): void => {
        val = searchText;
        if (!val) return;
        if (val?.length >= 3) {
          setSearchText(val);
          callSearchAPI(val);
        } 
        // else if (
        //   val?.length > 3 &&
        //   val?.substring(0, 3) === searchText?.substring(0, 3)
        // ) {
        //   const results = requests.filter(
        //     (item) =>
        //       item?.label.substring(0, val?.length).toLowerCase() ===
        //       val?.toLowerCase()
        //   );
        //   setRequests(results);
        //   setRequestsList(results);
        // } 
        else {
          // showToast(11,"Enter at least 3 charecters",'error')
          toast.info("Please enter at least 3 characters")
          // setRequests([]);
        }
      };
    
      const {
        handleSubmit,
        reset,
        formState: { errors },
      } = useForm<{ my_selections: RequestOption[] }>({
        defaultValues: { my_selections: [] },
      });
    
      const getRolesAppsAPI = async (): Promise<void> => {
        try {
          showLoader();
          const Jsondata ={
            division:selectedDivision[0]['id'],
            function:selectedFunction[0]['id'],
            role:selectedRole[0]['id']
          }
          const currentAppRoleList = await requestsService.getRoleAppList(Jsondata);
          // setSelectedId(currentAppList['appFormList']);
          // setSelectedItems(currentAppList['appFormList'])
          setSearchbyDivision(false);
          setRequests(currentAppRoleList);
          setRequestsList(currentAppRoleList);
          hideLoader();
        } catch (error) {
          console.error("Failed to fetch app list:", error);
          hideLoader();
        }
      };
    
      function gotoMyidmPage() {
        navigate("/myidmPortal");
      }
    
      const onFormSubmit = (): void => {
        console.log('111111111111111',mode);
        if(searchbyDivision){
          getRolesAppsAPI();
        }
        else{
          
        setSelectedOption(selectedItems)
        if(selectedOption){
        if (mode === 'NEW') {
        selectedOption["requestType"] = "NEW";
        }
        }
        setSelectedId(selectedItems);
        // setMode("NEW");
      }
      };
    const goToNewRequestPage = () =>{
      // navigate('/request-new-access')
      setRequests([]);
    }
    const handleSelect = (val: RequestOption) => {
      setSelectedOption(val);
    };
    const selectedValues = Object.entries(checkedItems)
      .filter(([_, checked]) => checked)
      .map(([id]) => id);
    
      const getActionInfo = (res: { resetSelection?: boolean }): void => {
      console.log("getActionInfo called with:", res);
      if (res?.resetSelection) {
        setSelectedOption(null);
        setSelectedId(null);
        setRequests([]);
        setSelectedItems([]);
        
      }
    };
    const handleSearchResult = (selectedApp: RequestOption) => {
        console.log("App selected in child:", selectedApp);
        // Do something with the selected app
        setRequests(selectedApp);
        setRequestsList(selectedApp);
        setRequestsCondition(selectedApp);
      };
    const handleSerachKeyword =(searchText:any)=>{
      setSearchedKeywords(searchText)
    }
    return (
        <>
        {requests?.length == 0 && ( 
        <div>
          <Breadcrumb
          homeIcon={{
            icon: "home",
            onClick:()=>{
              navigate("/home")
            }
          }}
          breadcrumbs={[
            {
              label: t("nonArExtension.home"),
            },
            {
              label: <div onClick={()=>{
                navigate("/myidmPortal")
              }}>{t("nonArExtension.myidm")}</div>
            },
            {
              label: <div onClick={()=>{
                navigate("/request-access")
              }}>{t("myIdmPortal.request_access")}</div>
            },
            {
              label: <div onClick={()=>{
                navigate("/request-new-access")
              }}>{t("myIdmPortal.request_new_access")}</div>
            }
          ]}
          className=""
          onClick={function Xs() {}}
          useAnchor
          style={{ marginBottom: "1rem !important",margin:"0rem 1rem 0rem 1rem" }}
        />
        <div className="request-new-access-for-self" style={{height:'69.6vh'}} id ="request-new-access">
            <p className="request-new-access-main-header" style={{marginBottom:'0.5rem'}}>{t('RequestNewAccessForSelf.request_new_access_for')}{state?.value ? ` ${state?.value}` : ` ${t('RequestNewAccessForSelf.self')}`}</p>
            <div className="request-new-access-main-content row h-100 m-0">
                <div className="col-md-6 d-flex justify-content-center align-items-center">
                    <SearchForAnApplication onAppSelect={handleSearchResult} SearchedKeyword={handleSerachKeyword} uid={gpid}/>
                </div>
                <div className="col-md-6 d-flex justify-content-center align-items-center">
                    <div className="search-for-an-application-icon" />
                </div>
            </div>
        </div>
        </div>
    )}
    {requests?.length > 0 &&(
    <div>
      <div
        id="landingPage"
        className="landingAlignments"
        style={{ display: "grid",fontSize:'12px',alignItems:'normal' }}
      >
        <Breadcrumb
          homeIcon={{
            icon: "home",
            onClick:()=>{
              navigate("/home")
            }
          }}
          breadcrumbs={[
            {
              label: t("nonArExtension.home"),
            },
            {
              label: <div onClick={()=>{
                navigate("/myidmPortal")
              }}>{t("nonArExtension.myidm")}</div>
            },
            {
              label: <div onClick={()=>{
                navigate("/request-access")
              }}>{t("myIdmPortal.request_access")}</div>
            },
            {
              label: t("RequestNewAccessForSelf.search"),
            },
          ]}
          className=""
          onClick={function Xs() {}}
          useAnchor
          style={{ marginBottom: "1rem !important" }}
        />
        
        <div className="header-text-1 mb-2"> {selectedId ? mode
  ? mode.charAt(0).toUpperCase() + mode.slice(1).toLowerCase()
  : '' : ''} {t('RequestNewAccessForSelf.request_access_for')} {state?.value ? state?.value : t('RequestNewAccessForSelf.self')}</div>
      </div>
    
    <div id="search-requests">
        <div className="card card-layout">
          <div className="card-content">
            <div className="arfw-search-header flex-req" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 0 }}>
            {!selectedId && (<div style={{ textAlign: "left" }}>
              <div>
                <p style={{ fontSize: '12px' }} className="mb-0">
                  <>
                  <strong>{requests?.length} {t('RequestNewAccessForSelf.search_result')}</strong> for{' '}
                  {searchedKeywords.length && !showSearchText && <>{searchedKeywords}</>}
                  {showSearchText && <>{showSearchText}</>}
                  {searchedKeywords.division && <>{t('RequestNewAccessForSelf.division')}: <strong>"{searchedKeywords.division}"</strong></>}
                  {searchedKeywords.function && <>, {t('RequestNewAccessForSelf.function')}: <strong>"{searchedKeywords.function}"</strong></>}
                  {searchedKeywords.role && <>, {t('RequestNewAccessForSelf.role')}: <strong>"{searchedKeywords.role}"</strong></>} 
                  {/* |{' '}
                  <Button
                    className=""
                    type="button"
                    onClick={goToNewRequestPage}
                    size="medium"
                    style={{ fontSize: '12px',display:'inline' }}
                    text={searchedKeywords.length?"Clear Search":"Clear"}
                    variant="tertiary"
                  /> */}
                  </>
                </p>
              </div>
                {/* <div className="header-text-2">Current Application Access</div> */}
              </div>
            )}
              
            {!selectedId && (
              
                  <Search
                    //   value={searchText}
                    isClearable={false}
                    menuPosition="bottom-right"
                    onClear={() => {
                      setRequests([]);
                      setSelectedItems([]);
                    }}
                    onSelectOption={handleSelect}
                    onSearch={(val: string) => getAppRequestTypes(val)}
                    onUpdate={updateSearchText}
                    placeholderText={t('RequestNewAccessForSelf.search_more_apps')}
                    size="medium"
                    isAutoComplete = {false}                    
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        getAppRequestTypes(searchText);
                      }
                    }}
                  />
                  
            )}
            </div>
            {!selectedId && !searchbyDivision && (
              <div className="container">
                <div className="box box1 p-2">
                  
                <div
                    style={{
                      maxHeight: "45vh", 
                      overflowY: "auto",
                      paddingRight: "8px",
                    }}
                  >
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}
                  >
                    {requests.map((item) => {
                      const isSelected = selectedItems.some(
                        (i: any) => i.id === item.id
                      );
                      return (
                        <div
                          key={item.id}
                          className={`app-access-list ${
                            isSelected ? "selected" : ""
                          }`}
                          style={{
                            flex: "1 0 32%",
                            minWidth: isMobile ? "100%" : "150px",
                            maxWidth:'32%',
                            border: isSelected
                              ? "2px solid #007bff"
                              : "1px solid #ccc",
                            padding: "0px",
                            cursor: "pointer",
                            borderRadius: "6px",
                            justifyContent: !item.myidm ? 'space-between' :'',
                            paddingBottom: item.myidm ? '2rem':'0px',
                          }}
                          onClick={() => handleToggle(item)}
                        >
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', padding: '10px 10px 0 10px' }}>
                          <h4 className="app-list-header mb-0">
                            <img src={app_image} style={{ width: "25px", marginRight: "5px" }} alt="Pepsico" />
                            {item.label}
                          </h4>

                          {(item.newRequestInProgress || item.modifyDisableRequestInProgress) && (
                          <Tooltip
                            direction="auto"
                            maxWidth="70px"
                            text={t('RequestNewAccessForSelf.pending_req_message')}
                          >
                              <p style={{
                                display: 'flex',
                                fontSize: '12px',
                                background: '#F2B3BC',
                                borderRadius: '15px',
                                padding: '0.1rem 0.5rem',
                                alignItems: 'center',
                                gap: '2px'
                              }}>
                                <Icon
                                  alt="alt value"
                                  className="$color-icon-default"
                                  icon="info"
                                  size="medium"
                                  style={{ fontSize: '14px' }}
                                />
                                <span>{t('RequestNewAccessForSelf.pending')}</span>
                              </p>
                          </Tooltip>
                          )}
                          {item?.currentAccessApp && (
                          <Tooltip
                            direction="auto"
                            maxWidth="70px"
                            text={t('RequestNewAccessForSelf.active_app')}
                          >
                           
                              <p style={{
                                display: 'flex',
                                fontSize: '12px',
                                background: '#0061C7',
                                borderRadius: '15px',
                                padding: '0.1rem 0.5rem',
                                alignItems: 'center',
                                gap: '2px',
                                color:'white'
                              }}>
                                <Icon
                                  alt="alt value"
                                  className="$color-icon-default"
                                  icon="info"
                                  size="medium"
                                  style={{ fontSize: '14px',color:'white' }}
                                />
                                <span>{t('RequestNewAccessForSelf.active')}</span>
                              </p>
                          </Tooltip>
                            )}
                        </div>
                        {/* <p className="app-list-approval mb-0">
                          {item?.newApproverLevels?.length} level approval
                        </p> */}
                        {/* <p className="app-list-text mb-0" dangerouslySetInnerHTML={{__html: item.desc,}}></p>
                          */}
                        
                        {/* {item.desc && (
                          <>
                            <p style={{padding:'10px'}}
                              className={`app-list-text mb-0 ${expandedItems[item.id] ? 'expanded' : 'collapsed'}`}
                              dangerouslySetInnerHTML={{ __html: item.desc }}
                            />
                            <div className="toggle-container">
                              <button
                                className="toggle-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleExpand(item.id);
                                }}
                              >
                                {expandedItems[item.id] ? 'Hide' : 'Show More'}
                              </button>
                            </div>
                          </>
                        )} */}
                        {item.desc ? (
                          <>
                          <p ref={(el) => (descRefs.current[item.id] = el)}
                            style={{ padding: '0 10px' }}
                            className={`app-list-text mb-1 ${expandedItems[item.id] ? 'expanded' : 'collapsed'}`}
                            dangerouslySetInnerHTML={{ __html: item.desc }}
                          />
                          {showMoreVisible[item.id] && (
                            <div className="toggle-container pr-2" style={{ padding: '0 10px' }}>
                              <button
                                className="toggle-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleExpand(item.id);
                                }}
                              >
                                {expandedItems[item.id] ? 'Hide' : 'Show More'}
                              </button>
                            </div>
                          )}
                        </>
                        ):<p style={{minHeight:'20px'}}></p>}
                        {/* {item.currentAccessApp && (
                          <div className="p-2" style={{background:'lightgoldenrodyellow',borderRadius:'3%',width:'100%'}}>
                            <p className="app-list-text mb-2 mt-2">
                              You already have access to this application.
                            </p>
                          </div>
                          
                        )} */}
                        {!item.myidm && (
                          <div className="p-2 banner-idm" onClick={(e) => {
                            e.stopPropagation();
                            gotoMyidm(item);
                          }}>
                            <Icon
                              alt="alt value"
                              className="$color-icon-default"
                              icon="info"
                              size="medium"
                              style={{color: "var(--Primitives-White, #FFF)",paddingLeft:'5px'}}
                            />
                            <p className="app-list-text mb-2 mt-2">
                            {t('RequestNewAccessForSelf.app_not_migrated')}
                            </p>
                            {/* <Button
                              className=""
                              size="large"
                              style={{display:'flex',justifySelf:'right'}}
                              text="MyIDM"
                              onClick={(e) => {
                                e.stopPropagation();
                                gotoMyidm(item);
                              }}
                              variant="primary"
                            /> */}
                              <Icon
                                alt="alt value"
                                className="$color-icon-default accordin-button-icon pr-2"
                                icon="arrow_forward"
                                style={{background:'transparent',color:'white',border:'none', fontSize: '16px'}}
                                size="medium"
                                onClick={(e) => {
                                e.stopPropagation();
                                gotoMyidm(item);
                              }}
                              />
                              {/* <ButtonIcon
                              className=""
                              type="button"
                              color="Interaction/Active"
                              icon="arrow_forward"
                              label="Label"
                              // onClick={(e) => {
                              //   e.stopPropagation();
                              //   gotoMyidm(item);
                              // }}
                              size="medium"
                              style={{background:'transparent',color:'white',border:'none'}}
                              type="default"
                            /> */}
                          </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  </div>
                  
                </div>
                
              </div>
            )}
            {!selectedId && searchbyDivision && (
              <div className="search-division">
                <form onSubmit={handleSubmit(onFormSubmit)}>
                <Controller
                  name="division"
                  control={control} 
                  render={({ field }) => (
                <>
                <Dropdown
                  childList={divisions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                  className="mb-3"
                  feedbackType="info"
                  isClearable = {true}
                  isRequired
                  label="Division"
                  menuPosition="bottom-right"
                  placeholder="Search..."
                  selection="single"
                  selectedValue={field.value}
                  setSelectedValue={(value) => {
                    field.onChange(value);
                    handleDivisionChange(value);
                  }}
                  size="medium"
                  style={{}}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {errors['division'] && <span className="error">This field is required</span>}
                </>
                )}
                />
                <Controller
                  name="function"
                  control={control} 
                  render={({ field }) => (
                <>
                <Dropdown
                  childList={functions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                  className="mb-3"
                  feedbackType="info"
                  isClearable
                  isRequired
                  label="Function"
                  menuPosition="bottom-right"
                  placeholder="Search..."
                  selection="single"
                  selectedValue={field.value}
                  setSelectedValue={(value) => {
                    field.onChange(value);
                    handleFunctionChange(value);
                  }}
                  size="medium"
                  style={{}}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {errors['function'] && <span className="error">This field is required</span>}
                </>
                )}
                />
                <Controller
                  name="role"
                  control={control} 
                  render={({ field }) => (
                <>
                <Dropdown
                  childList={roles?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                  className="mb-3"
                  feedbackType="info"
                  isClearable
                  isRequired
                  label="Role"
                  menuPosition="bottom-right"
                  placeholder="Search..."
                  selection="single"
                  selectedValue={field.value}
                  setSelectedValue={(value) => {
                    field.onChange(value);
                    handleRoleChange(value);
                  }}
                  size="medium"
                  style={{}}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {errors['role'] && <span className="error">This field is required</span>}
                </>
                )}
                />
                </form>
              </div>
            )}
            
            {!selectedId && selectedItems?.length > 0 && ( <hr
              className="custom-hr"
              style={{ marginBottom: "10px", marginTop: "16px" }}
            /> )}
            {!selectedId && selectedItems?.length > 0 && (
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div className="accountsAlign">
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <strong>{selectedItems?.length} {t('RequestNewAccessForSelf.selected')}</strong>
                </span>
                {selectedItems?.map((apps, index) => (
                  <span
                    key={index}
                    className="endPointInfo"
                    onClick={() => removeSelectedAPP(apps)} // pass index to remove
                    style={{ cursor: 'pointer', marginLeft: '8px' }}
                  >
                    {apps.label} {" X"}
                  </span>
                ))}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  className=""
                  type="button"
                  size="medium"
                  style={{}}
                  onClick={() => {
                    setRequests([]);
                    setSelectedItems([]);
                  }}
                  text={t('RequestNewAccessForSelf.cancel')}
                  variant="tertiary"
                />
                <Button
                  className=""
                  type="button"
                  size="medium"
                  style={{}}
                  onClick={() => {
                    setMode('NEW')
                    handleSubmit(onFormSubmit)();
                  }}
                  text="Request access"
                  variant="primary"
                />
              </div>
              </div>
            )}
          
            {selectedId && (
              <ArfFormAttributes
                selectedId={selectedId}
                setSelectRequest={getActionInfo} modeType={mode} uid ={gpid} setSelectedId={setSelectedId}
              />
            )}
          </div>
        </div>
        <ToastContainer
            position="bottom-center"
            data={toasts}
            removeToast={removeToast}
        />
      </div>
    </div>
    )}
    </>
    );

}


export default RequestNewAccessForSelf;